'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function HUFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-10k58qjuq", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-zz7g2fmts", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-upj56hvdw" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-upj56hvdw", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-10k58qjuq)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-upj56hvdw" }), /* @__PURE__ */ React.createElement("path", { fill: "#f14423", d: "M0 0h32v8H0z", mask: "url(#mantine-zz7g2fmts)" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 16h32v8H0z", mask: "url(#mantine-zz7g2fmts)" })))
  );
}

export { HUFlag };
//# sourceMappingURL=HU.mjs.map
